import { Actions } from ".";

type Callback = Record<Actions, (args: any[]) => any>;

export const ShopifyCart = {
  overrideFetch(callbacks: Callback) {
    const originalFetch = window.fetch;

    window.fetch = async (...args) => {
      const [url] = args;

      if (url.toString().includes("/cart/add.js")) {
        callbacks.add(args);
      } else if (url.toString().includes("/cart/update.js")) {
        callbacks.update(args);
      } else if (url.toString().includes("/cart/change.js")) {
        callbacks.remove(args);
      }

      return originalFetch(...args);
    };
  },
};

export const LocalStorageCart = {
  overrideFetch(callbacks: Callback) {
    if (!window.location.hostname.includes("culture-circle")) {
      return;
    }

    const originalSetItem = window.localStorage.setItem;
    window.localStorage.setItem = (key, value) => {
      if (key !== "cart") {
        return originalSetItem.call(window.localStorage, key, value);
      }

      const previous = window.localStorage.getItem(key);
      const current = JSON.parse(value || "[]");
      const previousLength = previous ? JSON.parse(previous || "[]").length : 0;
      const currentLength = current.length;

      if (previousLength === 0) {
        callbacks.add(current);
      } else if (
        previousLength < currentLength ||
        current.reduce((acc, item) => acc + item.quantity, 0) >
          (previous?.reduce?.((acc, item) => acc + item.quantity, 0) || 0)
      ) {
        callbacks.add(current);
      } else if (
        current.reduce((acc, item) => acc + item.quantity, 0) <
        (previous?.reduce?.((acc, item) => acc + item.quantity, 0) || 0)
      ) {
        callbacks.remove(current);
      } else {
        callbacks.update(current);
      }

      return originalSetItem.call(window.localStorage, key, value);
    };
  },
};
